class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.controls = this.querySelectorAll('[aria-controls]');

    this.hamburgerMenu = document.querySelector('.hamburger-menu button');
    this.backdrop = this.querySelector('.menu-drawer__backdrop');
  }

  connectedCallback() {
    // Toggle the drawer if the user clicks the hamburger menu or backdrop
    [this.hamburgerMenu, this.backdrop].forEach((el) => {
      el.addEventListener('click', () => this.toggleDrawer());
    });

    // Toggle the menu if the user clicks the control
    this.controls.forEach((control) => {
      if (!control) return;

      const controlValue = control.getAttribute('aria-controls');
      const target = this.querySelector(`#${controlValue}`);

      if (!target) return;

      control.addEventListener('click', () => {
        this.toggleMenu({
          controlValue,
          target,
          expanded: control.ariaExpanded === 'false',
        });
      });
    });
  }

  toggleDrawer() {
    const expanded = this.hamburgerMenu.ariaExpanded === 'false';
    this.hamburgerMenu.ariaExpanded = expanded;
    this.ariaHidden = !expanded;
  }

  toggleMenu({ controlValue, target, expanded }) {
    if (!controlValue || !target) return;

    const controls = this.querySelectorAll(`[aria-controls="${controlValue}"]`);

    controls.forEach((control) => {
      if (!control) return;

      control.ariaExpanded = expanded;
    });

    target.dataset.open = expanded;
  }
}

customElements.define('menu-drawer', MenuDrawer);
